const Index = () => import(/* webpackChunkName: "manager" */ './Index');

export default {
    routes: [
        {
            path: '/proj/concl/multi',
            name: 'proj_concl_multi_index',
            component: Index
        }
    ]
}
